export const filter = (object, fn) => {
	let newObject = {};
	for (let k in object) {
		const value = object[k];
		const keep = fn(value, k);
		if (keep) newObject[k] = value;
	}
	return newObject;
};

/**
 * removes all properties from an object except the ones provided in the array
 * @param {object} object the object to be filtered
 * @param {string[]} requiredProperties the attributes to be kept in the object
 */
export const keepOnly = (object = {}, ...requiredProperties) => {
	if (object === null || object === undefined) return object;
	return Object.keys(object)
		.filter((key) => requiredProperties.includes(key))
		.reduce((obj, key) => {
			obj[key] = object[key];

			return obj;
		}, {});
};

export const filterObject = (object, ...filters) => {
	if (object === null || object === undefined) return object;
	return Object.keys(object)
		.filter((key) => !filters.some((filter) => filter == key))
		.reduce((obj, key) => {
			obj[key] = object[key];

			return obj;
		}, {});
};

export const update = (object, keyToUpdate, newValue) => {
	return {...object, [keyToUpdate]: newValue};
};


export function getObjectDifference(obj1, obj2, mapper) {
	let diff = {};

	for (let key in obj1) {
		if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== undefined) {
			let nestedDiff = getObjectDifference(obj1[key], obj2[key], mapper);
			if (Object.keys(nestedDiff).length > 0) {
				diff[key] = nestedDiff;
			}
		} else if (key in obj2) {
			if (obj1[key] !== obj2[key]) {
				diff[key] = mapper ? mapper(obj1[key], obj2[key]) : {from: obj1[key], to: obj2[key]};
			}
		} else {
			diff[key] = mapper ? mapper(obj1[key]) : {from: obj1[key], to: undefined};
		}
	}

	for (let key in obj2) {
		if (!(key in obj1)) {
			diff[key] = mapper ? mapper(undefined, obj2[key]) : {from: undefined, to: obj2[key]};
		}
	}

	return diff;
}